"use strict";

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A builder for gRPC status objects.
 */

var StatusBuilder =
/*#__PURE__*/
function () {
  function StatusBuilder() {
    _classCallCheck(this, StatusBuilder);

    this.code = null;
    this.details = null;
    this.metadata = null;
  }
  /**
   * Adds a status code to the builder.
   */


  _createClass(StatusBuilder, [{
    key: "withCode",
    value: function withCode(code) {
      this.code = code;
      return this;
    }
    /**
     * Adds details to the builder.
     */

  }, {
    key: "withDetails",
    value: function withDetails(details) {
      this.details = details;
      return this;
    }
    /**
     * Adds metadata to the builder.
     */

  }, {
    key: "withMetadata",
    value: function withMetadata(metadata) {
      this.metadata = metadata;
      return this;
    }
    /**
     * Builds the status object.
     */

  }, {
    key: "build",
    value: function build() {
      var status = {};

      if (this.code !== null) {
        status.code = this.code;
      }

      if (this.details !== null) {
        status.details = this.details;
      }

      if (this.metadata !== null) {
        status.metadata = this.metadata;
      }

      return status;
    }
  }]);

  return StatusBuilder;
}();

exports.StatusBuilder = StatusBuilder;